import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../core/services/notification.service';
import { AdapterService } from '../../core/services/adapter.service';
import { AuthService } from '../../core/services/auth.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CartListModalComponent } from '../../shared/modals/cart-list-modal/cart-list-modal.component';
import { CartService } from 'src/app/core/services/cart.service';
import { NavService } from '../../core/services/nav.service';
import { Role } from 'src/app/core/enums/role.enum';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  list: any[] = [];
  isLoggedIn = false;
  isFotiouAdmin = false;
  isCustomerAdmin = false;
  isCustomerService = false;

  constructor(public _notificationService: NotificationService,
    private readonly _adapterService: AdapterService,
    private readonly _cartService: CartService,
    public _authService: AuthService,
    private readonly router: Router,
    private _modalService: NgbModal,
    public _navService: NavService) {

    this._cartService.onCartUpdate.subscribe((source: any) => {
      if (source != this)
        this._notificationService.getServerCount();
    });
  }

  ngOnInit(): void {
    this.isLoggedIn = this._authService.isLoggedIn();
    this.isFotiouAdmin = this._authService.getLoggedInUser()?.roleId == Role.FotiouAdmin;
    this.isCustomerAdmin = this._authService.getLoggedInUser()?.roleId == Role.CustomerAdmin;
    this.isCustomerService = this._authService.getLoggedInUser()?.roleId == Role.FotiouCustomerService;
  }

  openModal() {

    const ngbModalOptions: any = {
      backdrop: true,
      keyboard: false,

      windowClass: "cart-sidebar"
    };
    const modalRef = this._modalService.open(CartListModalComponent, ngbModalOptions);

    modalRef.result.then((response) => {
      if (response) {

      }
    });
  }
}
